'use client';

import { useI18n } from '~/features/i18n';
import { UspListItem } from './UspListItem';
import { I18n_AmountPerParticipant } from '~/features/i18n/translations';
import { Units } from '~/modules/units';
import { ActivityPDP_useCtx } from './context';
import { useShouldDisplayPrices } from '~/features/portals/money';
export const ActivityPDP_USP_Price: React.FC = _props => {
  const i18n = useI18n();
  const ctx = ActivityPDP_useCtx();
  const shouldDisplayPrices = useShouldDisplayPrices();
  if (!ctx.activity.variants.length || !shouldDisplayPrices) {
    return null;
  }
  return <UspListItem icon="budget" title={<I18n_AmountPerParticipant amount={Units.formatPriceRangeEUR(i18n, {
    minPrice: ctx.activity.priceRange?.min,
    maxPrice: ctx.activity.priceRange?.max
  })} disableEURPrefix={true} />} testId="activity-pdp-price">{i18n._("Based on {amount} participants", {
      amount: ctx.participants.state
    })}</UspListItem>;
};